export default __webpack_public_path__ + "static/media/wide_row_end.b78c92d8.svg";